import { useTranslation } from 'react-i18next';

import contactMain from '../assets/contact-main.png';
import emailIcon from '../assets/email.svg';
import phoneIcon from '../assets/phone.svg';

export const ContactsCard = () => {
  const { t } = useTranslation();
  const email = 'customer.care@pdfguru.com';
  const phone = '+1 (866) 716-6045';
  const addressByIp = '26 Stavrou Street, Strovolos 2034, Nicosia, Cyprus';

  return (
    <div className='box-content flex flex-col rounded-lg bg-[#F6F6F6] p-6 shadow-md lg:h-[446px] lg:min-w-[300px] lg:max-w-[274px]'>
      <div className='mb-6 flex justify-center'>
        <img
          src={contactMain}
          alt='Illustration'
          className='w-50 h-30'
        />
      </div>

      <div className='flex flex-col gap-4'>
        <div className='flex w-fit gap-3'>
          <div className='h-8 min-w-[32px]'>
            <img
              src={emailIcon}
              alt='email'
            />
          </div>
          <div className='flex flex-col gap-2'>
            <span className='w-fit font-bold'>{t('contact.email')}</span>
            <div className='h-6'>
              <a
                href={`mailto:${email}`}
                className='transition-all duration-300 ease-in-out hover:text-[#2038D4] focus:text-[#2038D4]'
              >
                <span>{email}</span>
              </a>
            </div>
          </div>
        </div>

        <div className='flex w-fit gap-3'>
          <div className='h-8 min-w-[32px]'>
            <img
              src={phoneIcon}
              alt='phone'
            />
          </div>
          <div className='flex flex-col gap-2'>
            <span className='w-fit font-bold'>{t('contact.phone')}</span>
            <div className='h-6'>
              <a
                href={`tel:${phone}`}
                className='transition-all duration-300 ease-in-out hover:text-[#2038D4] focus:text-[#2038D4]'
              >
                {phone}
              </a>
            </div>
          </div>
        </div>

        <div className='flex w-fit gap-3'>
          <div className='min-h-8 min-w-[32px]'>
            <img
              src={emailIcon}
              alt='address'
            />
          </div>
          <div className='flex flex-col gap-2 text-left'>
            <span className='w-fit font-bold'>{t('contact.address')}</span>
            <div className='min-h-[55px]'>
              <span dangerouslySetInnerHTML={{ __html: addressByIp }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
